import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TenderingService } from 'src/app/services/tendering/tendering.service';
import { User } from 'src/app/model/user.model';
import { AdmindashboardService } from 'src/app/services/dashboard/admin/admindashboard.service';
import { NgForm } from '@angular/forms';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-vendormessage',
  templateUrl: './vendormessage.component.html',
  styleUrls: ['./vendormessage.component.css']
})
export class VendormessageComponent implements OnInit {
data:any;
// dropdownList = [];
dropdownList : User[];
selectedItems = [];
dropdownSettings = {};
userid :any;

  constructor(private route:ActivatedRoute, private router:Router,
    private tenderingservices:TenderingService, private admindashboard:AdmindashboardService) { }

  ngOnInit() {
    this.GetRollList();
  
    //this.onItemSelect(); 
       this.dropdownSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'registerCode',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }
   onItemSelect(idField) {
   this.userid = idField.id;     
}
GetRollList() {
  debugger;
  this.admindashboard.GetRollsList().subscribe(
    (data: any) => {
      this.dropdownList = data;

      console.log(this.dropdownList);
    }
  )
}
messagesend(form:NgForm){
  debugger;
  form.value.toUserId =this.userid;
 // form.value.toUserId = "";
  if(form.value.message!=""&&form.value.selectedItems[0].registerCode !="")
  {
    // if(!isNullOrUndefined(this.selectedItems))
    // {
    //   for(var i=0; i<this.selectedItems.length;i++)
    //   {
    //     if(i < this.selectedItems.length-1)
    //     {
    //       form.value.toUserId = form.value.toUserId + this.selectedItems[i].id + ",";
    //     }
    //     else
    //     {
    //       form.value.toUserId = form.value.toUserId + this.selectedItems[i].id;
    //     }
    //   }
    // }
    //form.value.toUserId=this.userid;
    this.admindashboard.vendormessagesend(form.value).subscribe(
      (data)=>{
        this.data=data;
        console.log(data);
        if(data == true)
        {
          alert("Message Sent");
          form.reset();
        }
        else
        {
          alert("An Error Occured");
          form.reset();
        }
      }
    )
  }
  else{

  }
  
}
}
